export default __webpack_public_path__ + "static/media/not-checked.3295b31e.svg";